import { Text } from '@akin-home/text/native';

import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import {
  StyleProp,
  StyleSheet,
  TextStyle,
  TouchableOpacity,
  ViewStyle,
} from 'react-native';
import styled from 'styled-components/native';
import { button_styles, textSizeStyles, textVariantStyles } from './styles';
import { ButtonSizes, ButtonVariants } from './types';

export interface ButtonProps {
  size?: ButtonSizes;
  variant?: ButtonVariants;
  icon?: IconProp;
  iconColor?: string;
  iconSize?: number;
  testID?: string;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  disabled?: boolean;
  onPress?: () => void;
  onLongPress?: () => void;
  children?: React.ReactNode;
}

/** We should be using this button from now on */
export const Button = (props: ButtonProps) => {
  const {
    size = 'medium',
    variant = 'primary',
    icon,
    iconColor,
    iconSize,
    children,
    style,
    ...rest
  } = props;

  const styles = StyleSheet.flatten([
    button_styles[`${size}_${variant}_button`],
    otherStyles.buttonContainer,
    style,
  ]);

  return (
    <TouchableOpacity activeOpacity={0.4} style={styles} {...rest}>
      {icon ? (
        <IconContainer>
          <ButtonIcon
            button_size={size}
            text_variant={variant}
            icon={icon}
            color={iconColor}
            size={iconSize}
          />
        </IconContainer>
      ) : null}

      {typeof children === 'string' ? (
        <ButtonText
          variant="caption"
          weight="semibold"
          size={size}
          text_variant={variant}
          style={props.textStyle}
        >
          {children}
        </ButtonText>
      ) : (
        children
      )}
    </TouchableOpacity>
  );
};

const ButtonText = styled(Text)<{
  size?: ButtonSizes;
  text_variant?: ButtonVariants;
}>`
  ${({ size, text_variant }) => `
    ${textSizeStyles[size || 'medium']}
    ${textVariantStyles[text_variant || 'primary']}
  `}
`;

const ButtonIcon = styled(FontAwesomeIcon)<{
  button_size?: ButtonSizes;
  text_variant?: ButtonVariants;
}>`
  ${({ button_size, text_variant }) => `
    ${textSizeStyles[button_size || 'medium']}
    ${textVariantStyles[text_variant || 'primary']}
  `}
`;

const IconContainer = styled.View`
  flex-direction: row;
`;

const otherStyles = StyleSheet.create({
  buttonContainer: {
    gap: 8,
  },
});
